import { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Box, Divider, TextField } from "@mui/material";
import {
  getInputLabelProps,
  getInputProps,
  PopperFullWidth,
} from "../../../common/appStyles";
import localize from "../../../common/localize";
import Combobox from "../../../components/common/Combobox";
import useGlobalContext from "../../../hooks/useGlobalContext";
import ExecutionStatusField from "../../../components/common/ExecutionStatusField";

const AddStatusChange = ({
  currentStatus,
  eventData,
  newStatus,
  setNewStatus,
}) => {
  const { STATUS_CHANGE_SETUP_API, config } = useGlobalContext();
  const [nextStatusChanges, setNextStatusChanges] = useState();

  const statusExists = (status) => {
    if (status) {
      return true;
    }

    return false;
  };

  const removeDuplicates = (array) =>
    array.filter((item, index) => array.indexOf(item) === index);

  const getStatusChangesByWorkFlowId = async (workflowId) => {
    const data = await axios.get(
      `${STATUS_CHANGE_SETUP_API}/workflow/${workflowId}`,
      config
    );

    if (data?.data?.Ok) {
      setNextStatusChanges(
        removeDuplicates(
          data.data.Data.filter(
            (x) =>
              x.InitialStatus?.Id === currentStatus.Id &&
              statusExists(x.FinalStatus)
          )
        )
      );
      return;
    }

    setNextStatusChanges([]);
  };

  useEffect(() => {
    getStatusChangesByWorkFlowId(eventData?.EventType?.WorkFlow.Id);
  }, []);

  const handleChange = (e) => {
    setNewStatus({
      ...newStatus,
      [e.target.name]: e.target.value,
    });
  };

  const handleFinalStatusChange = (selectedFinalStatus) => {
    setNewStatus({
      ...selectedFinalStatus,
    });
  };

  return (
    <Box className="w-full flex flex-col gap-3 mt-2">
      <Box className="flex">
        <Box className="two_columns_grid">
          <label className="text-xs">
            <b>{localize.service_order}: </b>
          </label>
          <label className="text-xs">{eventData?.Id}</label>
          <label className="text-xs">
            <b>{localize.code}: </b>
          </label>
          <label className="text-xs">{eventData?.Code}</label>
          <label className="text-xs">
            <b>{localize.workflow}: </b>
          </label>
          <label className="text-xs">
            {eventData?.EventType?.WorkFlow?.Name}
          </label>
        </Box>
      </Box>

      <Divider />

      <Box className="flex gap-2 items-center">
        <Box sx={{ whiteSpace: "nowrap" }}>
          <label className="text-xs">
            <b>{localize.current_status}: </b>
          </label>
        </Box>

        <ExecutionStatusField executionStatus={currentStatus} />
      </Box>

      <Divider />

      <Combobox
        isRequired
        id="FinalStatus"
        fieldLabel={localize.new_status}
        fieldOptions={nextStatusChanges ?? []}
        fieldValue={newStatus ?? null}
        handleValueChange={handleFinalStatusChange}
        popperFullWidth={PopperFullWidth}
        customOptionLabel={(option) => option?.FinalStatus?.Name ?? ""}
      />

      <TextField
        InputLabelProps={getInputLabelProps()}
        inputProps={getInputProps()}
        value={newStatus?.Observation}
        onChange={handleChange}
        size="small"
        fullWidth
        multiline
        rows={6}
        id="Observation"
        label={localize.observations}
        name="Observation"
        variant="outlined"
      />

      {newStatus?.DynamicForm && (
        <Alert className="w-full" severity="info">
          <label className="text-xs">{`${localize.must_fill_dynamic_form} '${newStatus.DynamicForm.Name}' ${localize.after_saving_status_change}`}</label>
        </Alert>
      )}
    </Box>
  );
};

export default AddStatusChange;
